import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=60fe95e8"
import script from "./Conference.vue?vue&type=script&lang=js"
export * from "./Conference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports